import React, { useState, useContext, useEffect, Fragment } from 'react';
import { Segment, Form, Button, Label } from 'semantic-ui-react';

import { observer } from 'mobx-react-lite';
import { Form as FinalForm, Field } from 'react-final-form';

import {
  combineValidators,
  composeValidators,
  hasLengthLessThan,
  isNumeric,
  isRequired,
} from 'revalidate';

import { RootStoreContext } from '../../../../App/stores/RootStore'
import TextInput from '../../../../App/common/form/TextInput';
import { AdminDocumentFormValues, IAdminDocument } from '../../../../App/models/AdminDocument';
import TextAreaInput from '../../../../App/common/form/TextAreaInput';
import CheckboxInput from '../../../../App/common/form/CheckboxInput';

const validate = combineValidators({
  order: composeValidators(
    isNumeric('order'),
    isRequired('order'),
  )(),

  limit: composeValidators(
    isNumeric('limit'),
    isRequired('limit'),
  )(),

  type: composeValidators(
    isRequired('type'),
  )(),
  description: composeValidators(
    hasLengthLessThan(300)({ message: 'description has a 300 character limit' })
  )(),
});

interface DocumentsParams {
  document: IAdminDocument | undefined;
}

const AdminDocumentForm: React.FC<DocumentsParams> = (match) => {
  const rootStore = useContext(RootStoreContext);

  const { createAdminDocument, editAdminDocument, submitting, AdminDocumentRegistry } = rootStore.adminDocumentStore;
  const { closeModal } = rootStore.modalStore;

  const [adminDocument] = useState(new AdminDocumentFormValues(match.document));
  const [loading] = useState(false);

  if (!adminDocument.id) {
    adminDocument.order = AdminDocumentRegistry.size;
  }

  const handleFinalFormSubmit = (values: any) => {
    const { ...adminDocument } = values;

    if (!adminDocument.id) {
      let newAdminDocument = {
        ...adminDocument
      };
      createAdminDocument(newAdminDocument);
    }
    else {
      editAdminDocument(adminDocument);
    }
  };

  return (
    <Segment clearing>
      <FinalForm
        validate={validate}
        initialValues={adminDocument}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit, invalid, pristine }) => (
          <Form onSubmit={handleSubmit} loading={loading}>
            <Label>
              Document
            </Label>
            <Field
              rows={4}
              name='type'
              placeholder='type'
              value={adminDocument.type}
              component={TextInput}
            />
            <Label>
              Document is required
                </Label>
            <Field
              rows={4}
              name='required'
              type='checkbox'
              placeholder='required'
              checked={adminDocument.required}
              component={CheckboxInput}
            />
            <Label>
              Note is required
                </Label>
            <Field
              rows={4}
              name='noteRequired'
              type='checkbox'
              placeholder='noteRequired'
              checked={adminDocument.noteRequired}
              component={CheckboxInput}
            />
            <Label>
              Can fail review
                </Label>
            <Field
              rows={4}
              name='canFailReview'
              type='checkbox'
              placeholder='canFailReview'
              checked={adminDocument.canFailReview}
              component={CheckboxInput}
            />
            <Label>
              Order
            </Label>
            <Field
              rows={4}
              name='order'
              placeholder='order'
              value={adminDocument.order.toString()}
              component={TextInput}
            />
            <Label>
              Limit(0 means no limit)
                </Label>
            <Field
              rows={4}
              name='limit'
              placeholder='limit'
              value={adminDocument.limit.toString()}
              component={TextInput}
            />
            <Label>
              Description
            </Label>
            <Field
              rows={4}
              name='description'
              placeholder='description'
              value={adminDocument.description}
              component={TextAreaInput}
            />
            <Button
              loading={submitting}
              disabled={loading || invalid || pristine}
              floated='right'
              positive
              type='submit'
              content='submit'
            />
            <Button
              onClick={() => closeModal()}
              disabled={loading}
              floated='left'
              type='button'
              content='Cancel'
            />
          </Form>
        )}
      />
    </Segment>
  );
};

export default observer(AdminDocumentForm);
